import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {
    associaUtenteAGruppoApi,
    getUtentiNonAssociatiApi
} from "../services/GruppiUtentiServices";
import ModalAddAssociatiView from "./ModalAddAssociatiView";

export default function ModalAddAssociatiController({
                                              show,
                                              handleClose,
                                              handleOk,
                                              idGruppo
                                          }) {

    const [idUtenti, setIdUtenti] = useState([]);
    const [utentiNonAssociati, setUtentiNonAssociati] = useState([]);
    const [showMsg, setShowMsg] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext)

    async function getUtentiNonAssociati() {
        const response = await getUtentiNonAssociatiApi();
        setUtentiNonAssociati(response.data.data);
    }

    useEffect(() => {
        if (show === true) {
            getUtentiNonAssociati();
        }
    }, [idGruppo, show]);

    async function associaUtenteAGruppo(idUsr) {
        let rel = {
            id_gruppo_utente: idGruppo,
            id_utente: idUsr
        };
        const response = await associaUtenteAGruppoApi(idUsr, rel);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShowMsg(true)
        } else {
            getUtentiNonAssociati();
            setIdUtenti([]);
            handleOk();
        }
    }

    function onChangeUtente(event) {
        setIdUtenti(event.map(s => parseInt(s.value)));
    }

    function getValueUtenti() {
        // uso value per riuscire a recuperare gli stati pre-selezionati: defaultValue non funziona visto che le options
        // non sono caricate immediatamente
        utentiNonAssociati.filter((op, index) => {
            return idUtenti && idUtenti.includes(parseInt(op.id_utente))
        }).map((op, index) => {
            return {value: op.id_utente, label: op.cognome + ' ' + op.nome}
        })
    }

    function getOptionsUtenti() {
        utentiNonAssociati.map((op, index) => {
            return {value: op.id_utente, label: op.cognome + ' ' + op.nome};
        })
    }

    function onClickConferma() {
        if (idUtenti) {
            idUtenti.forEach((idUsr) => {
                associaUtenteAGruppo(idUsr);
            });
        }
    }

    return (
        <ModalAddAssociatiView
            setShowMsg={setShowMsg}
            translate={translate}
            show={show}
            modalMsg={modalMsg}
            handleClose={handleClose}
            showMsg={showMsg}
            onChangeUtente={onChangeUtente}
            getValueUtenti={getValueUtenti}
            getOptionsUtenti={getOptionsUtenti}
            onClickConferma={onClickConferma}
        />
    )

}